import { useState, useEffect, useCallback } from 'react'
import { Modal, Row, Col, Card, Button } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useLoading } from '../../../hooks/LoadingContext'

import api from '../../../services/api'

import styles from './styles.module.css'

function MaintancesModal({ show, close, vehicleId }) {
  const [maintances, setMaintances] = useState([])
  const { isLoading, setIsLoading } = useLoading()
  const [loadingEnded, setLoadingEnded] = useState(false)

  function formatMaintanceDate(date) {
    date = new Date(date)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth()).padStart(2, '0')
    const year = date.getFullYear()
    const hour = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getMinutes()).padStart(2, '0')
    return `${day}/${month}/${year} às ${hour}:${minutes}:${seconds}`
  }

  const loadData = useCallback(
    async (limit = 10, offset = 0) => {
      setIsLoading(true)
      try {
        const { data } = await api.get(
          `/company/vehicles/${vehicleId}/maintances?limit=${limit}&offset=${offset}`,
        )
        if (!data.length && offset !== 0) {
          setLoadingEnded(true)
          toast.info('Não há mais manutenções cadastradas para o veículo.')
        } else setMaintances((maintances) => [...maintances, ...data])
      } catch (err) {
        toast.error('Falha ao buscar os dados das manutenções. Tente novamente mais tarde')
        close()
      }
      setIsLoading(false)
    },
    [vehicleId, close, setIsLoading],
  )

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal centered show={show} onHide={close}>
      <Modal.Header className="border-0" closeButton />
      <Modal.Body className={styles.container}>
        <Row>
          {!maintances?.length && !isLoading && (
            <span className={`${styles.infoBadge} text-center`}>Nenhuma manutenção cadastrada</span>
          )}
        </Row>
        {maintances?.map((maintance, index) => (
          <Card style={{ width: '100%', marginBottom: 15 }} key={index}>
            <Card.Body>
              <Card.Title
                style={{
                  fontSize: 17,
                  textAlign: 'center',
                }}
                className="mb-2 text-dark"
              >
                {maintance.title}
              </Card.Title>
              <Card.Text style={{ fontSize: 14 }}>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>
                    {maintance.driver ? 'Motorista: ' : 'Gestor de entregas: '}
                  </span>
                  {maintance.driver ? maintance.driver.name : maintance.delivery_manager.name}
                </p>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>Data: </span>
                  {formatMaintanceDate(maintance.date)}
                </p>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>Quilometragem: </span>
                  {maintance.mileage ?? 'Não informada'}
                </p>
                <p style={{ marginBottom: 8 }}>
                  <span style={{ fontWeight: 'bold' }}>Custo: </span>
                  R$ {maintance.cost}
                </p>
                <p>
                  <span style={{ fontWeight: 'bold' }}>Descrição: </span>
                  {maintance.description}
                </p>
              </Card.Text>
              <div style={{ textAlign: 'center' }}>
                <Button
                  className={styles.invoiceBtn}
                  onClick={() => window.open(maintance.invoice_url, '_blank')}
                >
                  Nota fiscal
                </Button>
              </div>
            </Card.Body>
          </Card>
        ))}
        {maintances.length ? (
          <Col className="col-12 mt-3 mb-3 text-center">
            <Button
              className={styles.loadMoreBtn}
              disabled={loadingEnded}
              onClick={() => {
                setIsLoading(true)
                loadData(10, maintances.length)
                setIsLoading(false)
              }}
            >
              Carregar 10 próximas
            </Button>
          </Col>
        ) : null}
      </Modal.Body>
    </Modal>
  )
}

export default MaintancesModal
